let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Jr6Pb")).then(() => parcelRequire('eyIad'));